import img17a from '../../../assets/gallery/17c/17c-01-HOME_Variaciones-2017-200x150cm-oleo-sobre-madera.jpg';
import img17b from '../../../assets/gallery/17c/17c-02_ST-2017-200x150cm-oleo-sobre-madera.jpg';
import img17c from '../../../assets/gallery/17c/17c-03_ST-2017-200x150cm-oleo-sobre-madera.jpg';

export const dataImages = [
  {
    id: 1,
    title: "",
    dimensions: "200 x 150 cm",
    pictureSrc: img17a,
    description: "2017",
    orientation: "v"
  },
  {
    id: 2,
    title: "",
    dimensions: "200 x 150 cm",
    pictureSrc: img17b,
    description: "2017",
    orientation: "v"
  },
  {
    id: 3,
    title: "",
    dimensions: "200 x 150 cm",
    pictureSrc: img17c,
    description: "2017",
    orientation: "v"
  },
].sort(() => Math.random() - 0.5);

export const dimensionsH = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


export const dimensionsV = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


// WEBPACK FOOTER //
// ./src/pages/gallery/17c/data17c.js